import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ITimeZone } from '../types/ITimeZone';

export interface IGetUserSelectableTimeZonesParams {
}

export interface IGetUserSelectableTimeZonesResult {
    extraTimeZonesList: ITimeZone[];
    curatedTimeZonesList: ITimeZone[];
    serverTimeZone: ITimeZone;
}

export class GetUserSelectableTimeZonesRequest extends Request<IGetUserSelectableTimeZonesParams, IGetUserSelectableTimeZonesResult> {
    constructor(params: IGetUserSelectableTimeZonesParams = {}) {
        super('getUserSelectableTimeZones', params);
    }
}
